/* Urban Calm quiz loader: defer the full quiz engine until a visitor shows intent to use it. */
(function(){
  'use strict';
  if(window.__ucQuizLoaderReady)return;
  window.__ucQuizLoaderReady=true;

  var current=document.currentScript;
  var loaderSrc=current&&current.src?current.src:'';
  var queryIndex=loaderSrc.indexOf('?');
  var query=queryIndex>=0?loaderSrc.slice(queryIndex):'';
  var base=queryIndex>=0?loaderSrc.slice(0,queryIndex):loaderSrc;
  var coreSrc=base.replace(/uc-mushroom-quiz\.js$/,'uc-mushroom-quiz-core.js')+query;
  var loaded=false;
  var loading=false;
  var callbacks=[];

  function finish(){
    loaded=true;
    loading=false;
    var queued=callbacks.splice(0,callbacks.length);
    queued.forEach(function(callback){try{callback()}catch(e){}});
  }

  function load(callback){
    if(typeof callback==='function')callbacks.push(callback);
    if(loaded){finish();return}
    if(loading)return;
    if(!coreSrc||coreSrc===loaderSrc){loading=false;return}
    loading=true;
    var script=document.createElement('script');
    script.src=coreSrc;
    script.async=true;
    script.onload=finish;
    script.onerror=function(){loading=false;callbacks.length=0};
    document.head.appendChild(script);
  }

  function findTrigger(target){return target&&target.closest?target.closest('[data-ucm-quiz]'):null}

  function warm(event){if(findTrigger(event.target))load()}

  function intercept(event){
    var trigger=findTrigger(event.target);
    if(!trigger||loaded)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load(function(){
      document.removeEventListener('click',intercept,true);
      if(document.contains(trigger))trigger.click();
    });
  }

  document.addEventListener('pointerdown',warm,{passive:true,capture:true});
  document.addEventListener('focusin',warm,true);
  document.addEventListener('click',intercept,true);

  function loadForHash(){if(window.location.hash==='#find-my-blend')load()}
  loadForHash();
  window.addEventListener('hashchange',loadForHash);

  if(window.Shopify&&Shopify.designMode)load();
})();
